<template>
  <div class="home">
    <van-nav-bar title="公司介绍" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-tabs type="card" color="rgba(38, 60, 146, 1)">
      <van-tab title="公司简介">
        <div class="navheight"></div>
        <div class="infobox">
          <img src="../assets/companyimg/info.png" alt="" width="100%">
        </div>
      </van-tab>
      <van-tab title="子公司">
        <div class="navheight"></div>
        <div class="infodetail"> 
          <img src="../assets/companyimg/tit.png" alt="" width="100%">
          <!-- <img src="../images/info2.png" alt="" srcset="" width="100%"> -->
          <ul>
            <li>
              <div class="title">北京中科基因技术有限公司</div>
              <div class="info">
                <div><span> 办公地址：</span><p>北京市海淀区中关村南大街12号天作国际中心1号楼A座1702</p></div>
                <div class="phone"><span class="twoPhone">技术支持：</span><a class="tel1" :href="link" @click="tel('400-001-2129')">400-001-2129</a></div> 
                <div><span>办公邮箱：</span><p>adminis@sslab.com.cn</p> </div>
              </div>
            </li>
            <li>
              <div class="title">北京中科基因技术有限公司检测技术分公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>北京市大兴区生物医药基地祥瑞大街19号</p></div>
                <div class="phone"><span class="twoPhone">接样电话：</span><a class="tel1" :href="link" @click="tel('15010658103')">15010658103</a></div> 
                <div><span>业务邮箱：</span><p>beijinglab@sslab.com.cn</p> </div> 
              </div>
            </li>
            <li>
              <div class="title">洛阳中科基因检测诊断中心有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>河南省洛阳市高新区华夏路6号中科科技园</p></div>
                <div class="phone"><span class="twoPhone">接样电话：</span><a class="tel1" :href="link" @click="tel('15824954772')">15824954772</a></div> 
                <div class="phone1"><span class="twoPhone">业务电话：</span> <a class="tel1" :href="link" @click="tel('18037001692')">18037001692</a><br/><a class="tel1" :href="link" @click="tel('0379-60687955')">0379-60687955</a> </div>
                <div><span>业务邮箱：</span><p>luoyanglab@sslab.com.cn</p> </div>
              </div>
            </li>
            <li>
              <div class="title">陕西中科基因检测技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>陕西省咸阳市泾阳县泾永路中段永乐工业园区</p></div>
                <div class="phone"><span class="twoPhone">接样电话：</span><a class="tel1" :href="link" @click="tel('13363935472')">13363935472</a></div> 
                <div><span>业务邮箱：</span><p>xi.anlab@sslab.com.cn</p></div>
              </div>
            </li> 
            <li>
              <div class="title">湖南中科基因检测技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>湖南省长沙市岳麓区文轩路27号麓谷企业广场F1栋1906</p></div>
                <div class="phone">
                  <span class="twoPhone">接样电话：</span>
                  <a class="tel1" :href="link" @click="tel('13347318870')">13347318870</a>
                  <a class="tel1" :href="link" @click="tel('0731-84727768')">0731-84727768</a>
                </div> 
                <div> <span>业务邮箱：</span><p>changshalab@sslab.com.cn</p> </div>
              </div>
            </li>  
            <li>
              <div class="title">广州中科基因检测服务有限公司</div>
              <div class="info">
                <div> <span>送样地址：</span><p>广州黄埔区新瑞路6号西陇科学二栋B501</p></div>
                <div class="phone"><span class="twoPhone">接样电话：</span><a :href="link" class="tel1" @click="tel('13924260092')">13924260092</a> </div> 
                <div><span>业务邮箱：</span><p>guangzhoulab@sslab.com.cn</p> </div> 
              </div>
            </li>   
            <li>
              <div class="title">青岛中科基因生物技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>青岛市高新区河东路368号青岛蓝色生物医药产业园8号楼4楼</p></div> 
                <div class="phone"><span class="twoPhone">接样电话：</span><a :href="link" class="tel1" @click="tel('18563996162')">18563996162</a> </div> 
                <div><span>业务邮箱：</span><p>qingdaolab@sslab.com.cn</p> </div> 
              </div>
            </li> 
            <li>
              <div class="title">哈尔滨中科基因技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>哈尔滨市松北区科技创新城创新一路2305号三楼a区</p></div> 
                <div class="phone"><span class="twoPhone">接样电话：</span><a :href="link" class="tel1" @click="tel('18946066484')">18946066484</a> </div>
                <div><span>业务邮箱：</span><p>haerbinlab@sslab.com.cn</p> </div>
              </div>
            </li> 
            <li>
              <div class="title">福州中科基因技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>福建省福州市仓山区建新镇金山大道618号金山工业园桔园洲园37#六层601</p></div> 
                <div class="phone"><span class="twoPhone">接样电话：</span><a :href="link" class="tel1" @click="tel('18050778290')">18050778290</a> </div>
                <div><span>业务邮箱：</span><p>fuzhoulab@sslab.com.cn</p> </div>
              </div>
            </li>
            <li>
              <div class="title">山西中科基因检测技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>山西省晋中市太谷县丰农城西农产品批发市场东临街1号商铺</p></div> 
                <div class="phone">
                  <span class="twoPhone">接样电话：</span>
                  <a class="tel1" :href="link" @click="tel('15582408123')">15582408123</a>
                  <a class="tel1" :href="link" @click="tel('0354-6139333')">0354-6139333</a>
                </div>
                <div><span>业务邮箱：</span><p>jinzhonglab@sslab.com.cn</p> </div> 
              </div>
            </li> 
            <li>
              <div class="title">杭州洪桥中科基因技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>浙江省杭州经济技术开发区6号大街452号高科技孵化园区2幢B2005</p></div> 
                <div class="phone">
                  <span class="twoPhone">接样电话：</span>
                  <a class="tel1" :href="link" @click="tel('18969925693')">18969925693</a>
                  <a class="tel1" :href="link" @click="tel('0571-86849360')">0571-86849360</a>
                </div> 
                <div><span>业务邮箱：</span><p>hangzhoulab@sslab.com.cn</p> </div> 
              </div>
            </li> 
            <li>
              <div class="title">辽宁中科基因技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>辽宁省沈阳市苏家屯区桂竹香街68号6F-2</p></div> 
                <div class="phone"><span class="twoPhone">接样电话：</span><a class="tel1" :href="link" @click="tel('13166669100')">13166669100</a> </div> 
                <div><span>业务邮箱：</span><p>shenyanglab@sslab.com.cn</p> </div> 
              </div>
            </li>
            <li>
              <div class="title">江西中科基因检测技术有限公司</div>
              <div class="info">
                <div> <span>送样地址：</span><p>江西省南昌市南昌高新区天祥大道瑶湖西七路929号</p></div>
                <div class="phone"><span class="twoPhone">接样电话：</span><a :href="link" class="tel1" @click="tel('13319369977')">13319369977</a> </div> 
                <div><span>业务邮箱：</span><p>nanchanglab@sslab.com.cn</p> </div> 
              </div>
            </li>
            <li>
              <div class="title">常州中科基因技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>江苏省常州市长扬路9号西太湖医疗产业孵化园D1栋五楼</p></div> 
                <div class="phone"><span class="twoPhone">接样电话：</span><a class="tel1" :href="link" @click="tel('18015861811')">18015861811</a> </div>
                <div><span>业务邮箱：</span><p>changzhoulab@sslab.com.cn</p> </div> 
              </div>
            </li>
            <li>
              <div class="title">四川天府中科基因技术有限公司</div>
              <div class="info">
                <div><span>送样地址：</span><p>四川省成都市温江区永宁镇芙蓉大道二段733号6栋8层</p></div> 
                <div class="phone">
                  <span class="twoPhone">接样电话：</span>
                  <a class="tel1" :href="link" @click="tel('18283581269')">18283581269</a>
                  <a class="tel1" :href="link" @click="tel('15378277188')">15378277188</a>
                </div> 
                <div><span>业务邮箱：</span><p>chengdulab@sslab.com.cn</p> </div> 
              </div>
            </li>
            <li>
              <div class="title">洛阳中科生物芯片技术有限公司</div>
              <div class="info">
                <div><span>办公地址：</span><p>河南省洛阳市高新区华夏路6号中科科技园</p></div> 
                <div class="phone"><span class="twoPhone">办公电话：</span><a class="tel1" :href="link" @click="tel('0379-69937993')">0379-69937993</a> </div> 
              </div>
            </li>
          </ul>
          <img src="../assets/companyimg/bottom2.png" alt="" width="100%">
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'Home',
  data(){
    return{
      link: '',
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
    }
  },
  created(){
  },
  methods: {
    onClickLeft() {
      if (this.browser.android) {
        ZKAPP.back();
      }else {
        window.webkit.messageHandlers.back.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    tel(val) {
      console.log('1',val)
      if (this.browser.android) {
        this.link = 'tel:'+val
      }else {
        this.link = 'javascript:;'
        window.webkit.messageHandlers.jsToOcTelePhone.postMessage({tel:val});
      }
    },
    testtime() {
      if (new Date(this.time)-new Date() <= 0) {
        clearInterval(this.timer)
        console.log('时间到了')
      }
    },
  }
}
</script>

<style lang="scss">
.van-tabs__content {
  font-size: 0;
}
.van-tabs__wrap {
  position: fixed;
  top: 46px;
  width: 100%;
  padding: 10px 0 10px;
  background: #fff;
  z-index: 999;
}
.van-tabs__nav--card {
  margin: 0 40px;
}
.navheight {
  height: 96px;
}
.infobox {
  margin-top: 10px;
}
.infodetail{
  margin-top: 10px;
  font-size: 0;
  background: #fff;
  color: rgba(51, 51, 51, 1);
  ul {
    li {
      margin: 10px 15px;
      padding: 10px 0;
      border-bottom: 1px solid  rgba(238, 238, 238, 1);
      &:last-child {
        border-bottom: none;
      }
      .title{
        text-align: left;
        font-size: 16px;
        font-weight: 600;
      }
      .info{
        position: relative;
        margin: 10px 0 15px 0;
        text-align: left;
        font-size: 16px;
        .phone {
          margin: 10px 0;
          a {
            display: block;
            margin-bottom: 8px;
          }
        }
        .phone1 {
          margin-bottom: 10px;
          a {
            display: block;
            margin-bottom: -5px;
          }
        }
        .twoPhone{
          width: 80px;
        }
        a {
          text-decoration: underline;
          color: rgba(38, 60, 146, 1);
          margin-left: 80px;
        }
      }
      span{
        position: absolute;
      }
      p{
        padding-left: 80px;
      }
      img{
        width: 18px;
        height: 17px;
        display: inline-block;
        margin-right: 0px;
      }
    }
  }
}
</style>
